import type { Meta, StoryObj } from "@storybook/react";

import type { SectionEmptyListCardProps } from "@/ui/composed/cards/SectionEmptyListCard";
import SectionEmptyListCard from "@/ui/composed/cards/SectionEmptyListCard";

const StoryMeta: Meta<SectionEmptyListCardProps> = {
  title: "Components/Common/SectionEmptyListCard",
  component: SectionEmptyListCard,
  argTypes: {
    onButtonPress: { action: "Button pressed" },
  },
};

type Story = StoryObj<SectionEmptyListCardProps>;

const Primary: Story = {
  args: {
    buttonTitle: "Book an appointment",
    description:
      "Did you know you can book appointments with your provider team using the Equip App? You can even set up recurring sessions.",
    title: "No upcoming events",
  },
};

const WithCallback: Story = {
  args: {
    onButtonPress: () => {
      console.log("Book appointment pressed");
    },
  },
};

export { Primary, WithCallback };
export default StoryMeta;
